import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateNotification } from "../../../../../components/notifier";
import { documentTagsService } from "../../../../../services/document/document-tags.service";

export const useCreateDocumentTag = () => {
  const queryClient = useQueryClient();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (variables: { Title: string; eTagType: string }) => {
      return documentTagsService.create(variables);
    },
  });

  const createDocumentTag = (
    variables: { Title: string; eTagType: string },
    options?: { onSuccess?: (data: any) => void; onError?: () => void },
  ) => {
    mutate(variables, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({ queryKey: ["document-tags"] });
        CreateNotification({ title: "Thành công", body: "Thêm chủ đề thành công", icon: "/icons/success.png", });
        if (options?.onSuccess) {
          options.onSuccess(response);
        }
      },
      onError() {
        CreateNotification({ title: "Thất bại", body: "Thêm chủ đề thất bại", icon: "/icons/warning.png" });
        if (options?.onError) {
          options.onError();
        }
      },
    });
  };

  return { ...restMutation, mutate, createDocumentTag };
};
